module.exports = __webpack_public_path__ + "static/media/cycle_icon.62d4ae14.svg";